import { render, staticRenderFns } from "./ImportarEmpenhoSIAF.vue?vue&type=template&id=d701b6c4&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./ImportarEmpenhoSIAF.vue?vue&type=style&index=0&id=d701b6c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d701b6c4",
  null
  
)

export default component.exports